// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import  * as mui from './assets/mui/js/mui.js'
// import './assets/mui/css/mui.css'

Vue.prototype.$mui=mui;

import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from "vue-router";
import ElementUI from 'element-ui'
import Vuex from 'vuex'
import store from './store'
import PublicMethod from './assets/js/public'
import 'element-ui/lib/theme-chalk/index.css'
import BaiduMap from 'vue-baidu-map'




Vue.use(BaiduMap, {
	/* 需要注册百度地图开发者来获取你的ak */
	ak: 'rhN7HVniKACwIfaA4FGscdsuVn8MEPYL'
})

//push
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}

import * as filters from './assets/js/filters'
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key]) //插入过滤器名和对应方法
})
// 布置路由守卫添加socket
router.beforeEach((to, from, next) => {
	// console.log(to,from)
	// 需要使用到websocket的路由名字
	// const socketRouter = ['Home', 'DoingMeetingsActivity']
	// // console.log(socketRouter)
	// socketRouter.forEach(res => {
	if (to.name !== 'Login') {
		$ws.newsocket()
	}
	// })
	// $ws.newsocket()
	next()
})


//replace
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
	return VueRouterReplace.call(this, to).catch(err => err)
}
Vue.config.productionTip = false
Vue.use(ElementUI);
// 挂载全局websocket
import {
	$ws
} from "@/assets/js/websocket/newsocket"
Vue.use($ws)
Vue.use(Vuex)
Vue.use(PublicMethod)

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

/* eslint-disable no-new */
new Vue({
	strict:false,
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js